export enum PostType {
    default = 'post',
    announcement = 'announcement',
}

export type ReactionType = 'like' | 'heart'

export interface PostAuthor {
    id: string
    name?: string
    image?: string
}

export interface Post {
    id: string
    type: PostType
    title?: string
    text?: string
    images: string[]
    author: PostAuthor
    createdAt: Date
    likeCount: number
    hasLiked: boolean
    heartCount: number
    hasHearted: boolean
    commentCount: number
}
